import { type Scale } from "../../lens-stats/formatters";

export const roundWithScale =
    (scale: (typeof Scale)[keyof typeof Scale]) =>
    (number: number | string | undefined): number =>
        Math.round((Number(number) + Number.EPSILON) * scale) / scale;
